import { Component, AfterViewInit } from '@angular/core';
import { StructureDiagramLayoutManager } from './structure-diagram-layout-manager';
import { RelationshipDiagram } from './relationship-diagram.model';
import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';

import { plainToClass } from 'class-transformer';
import { MdDialogRef } from '@angular/material';


@Component({
    selector: 'app-relationship-diagram',
    templateUrl: 'relationship-diagram.component.html',
    styleUrls: ['relationship-diagram.component.css']
})

export class RelationshipDiagramComponent implements AfterViewInit {
    public entityId: any;
    public relationshipDiagramId = 'relationship_diagram';

    constructor(private dialogRef: MdDialogRef<any>, private entityRelationsService: EntityRelationsService) { }

    ngAfterViewInit() {
        setTimeout(() => {
            if (!this.entityId) {
                return;
            }
            this.entityRelationsService.getEntityRelationShipDiagram(this.entityId)
                .map(response => plainToClass(RelationshipDiagram, response.arrResult as Object))
                .subscribe(response => StructureDiagramLayoutManager.draw(response, this.relationshipDiagramId));
        }, 0);
    }

    zoomIn() {
        StructureDiagramLayoutManager.zoomIn(this.relationshipDiagramId);
    }

    zoomOut() {
        StructureDiagramLayoutManager.zoomOut(this.relationshipDiagramId);
    }

    resetZoom() {
        StructureDiagramLayoutManager.resetZoom(this.relationshipDiagramId);
    }

    closeDialog() {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/relationship-diagram/relationship-diagram.component.ts